module.exports = __webpack_public_path__ + "static/img/trinity-stacked.42a9ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trinity-stacked.jpg
// module id = 9MfB
// module chunks = 0